export function InviteShell({ children }: { children: React.ReactNode }) {
  return (
    <div className="grid min-h-svh lg:grid-cols-2">
      <div className="relative hidden bg-muted lg:block">
        <div className="absolute inset-0 bg-gradient-to-br from-primary/20 via-primary/10 to-background" />
        <div className="absolute inset-0 flex items-center justify-center p-12">
          <div className="max-w-lg text-center">
            <div className="mb-4">
              <img
                src="/assets/medblocks.webp"
                alt="Medblocks"
                className="mx-auto size-24 object-contain"
              />
            </div>
            <h2 className="mb-4 text-3xl font-bold tracking-tight">
              Medblocks Platform
            </h2>
            <p className="text-lg text-muted-foreground">
              Securely manage patient health records, connect with healthcare providers, and get verified answers on the complete patient record.
            </p>
          </div>
        </div>
      </div>
      <div className="flex flex-col gap-4 p-6 md:p-10">
        <div className="flex justify-center gap-2 md:justify-start">
          <div className="flex items-center gap-0 font-medium">
            <img src="/assets/medblocks.webp" alt="" className="size-11 object-contain" />
            Medblocks Platform
          </div>
        </div>
        <div className="flex flex-1 items-center justify-center">
          <div className="w-full max-w-sm">{children}</div>
        </div>
      </div>
    </div>
  );
}
